import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Button,
  Box,
  Typography,
  makeStyles,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 8,
    minWidth: 500,
  },
  content: {
    padding: theme.spacing(4, 4, 3, 4),
    textAlign: "center",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    top: 8,
    right: 8,
    color: "#e53935",
  },
  icon: {
    fontSize: 56,
    color: "#43a047",
  },
  title: {
    fontWeight: 700,
    marginTop: theme.spacing(1),
  },
  bullets: {
    listStyle: "disc",
    padding: 0,
    margin: theme.spacing(2, 0, 0, 10),
    textAlign: "left",
    // color: "#ec6535",
  },
  bullet: {
    margin: "4px 0",
    fontSize: "0.95rem",
  },
  message: {
    marginTop: theme.spacing(1),
    color: "#444",
    fontSize: "0.95rem",
  },
  okBtn: {
    backgroundColor: "#ec6535",
    color: "#fff",
    textTransform: "none",
    borderRadius: 4,
    minWidth: 80,
    marginTop: theme.spacing(3),
    "&:hover": { backgroundColor: "#9E4D27" },
  },
}));

export default function ForecastSuccessModal({ open, text, info, onClose }) {
  const classes = useStyles();
  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <DialogContent className={classes.content}>
        <IconButton size="small" className={classes.closeBtn} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <CheckCircleIcon className={classes.icon} />
        <Typography variant="h6" className={classes.title}>
          {text}
        </Typography>
        {info && (info.cmoLabel || info.brand || info.receivedOn) && (
          <ul className={classes.bullets}>
            {info.cmoLabel && (
              <li className={classes.bullet}><Typography className={classes.message}>CMO name - {info.cmoLabel}</Typography></li>
            )}
            {info.brand && (
              <li className={classes.bullet}><Typography className={classes.message}>Brand name - {info.brand}</Typography></li>
            )}
            {info.receivedOn && (
              <li className={classes.bullet}>
                <Typography className={classes.message}>Forecast received on - {info.receivedOn}</Typography>
              </li>
            )}
          </ul>
        )}
        <Box>
          <Button className={classes.okBtn} onClick={onClose}>
            Ok
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
